module.exports = __webpack_public_path__ + "img/refrigeracion_colman.e4fd3e04.png";